var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWltLogoSmallEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45.551,
    height: 15.176,
    viewBox: "0 0 45.551 15.176",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".a{fill:#ddd;}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.204 -7.14)",
    id: "g5"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m 52.446678,10.519 v 6.714 h 4.014 v 1.522 h -5.822 v -8.236 z",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m 42.215671,12.042 v -1.523 h 6.748 v 1.522 h -2.469 v 6.714 h -1.81 v -6.713 z",
    id: "path3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.022,11.618H12.2V7.14h4.737V8.958H14.022Zm0,6.219H12.2v4.478h4.737V20.5H14.022Zm11.54-5.961H27.38V7.14H22.643V8.958h2.919Zm0,8.621H22.643v1.818H27.38V17.579H25.562Z",
    id: "path4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.993,25.519H30v1.957h2.016v3.991h1.957V27.476h2.016Z",
    transform: "translate(-13.206 -13.636)",
    id: "path5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 28.484964,3.3540154 25.590433,11.756359 H 23.445902 L 20.586527,3.3540154 h 2.039062 l 1.751953,5.8476562 q 0.140625,0.4746094 0.169922,0.8378904 h 0.03516 q 0.04102,-0.3925779 0.18164,-0.8613279 l 1.740235,-5.8242187 z",
    id: "text5",
    style: {
      fontWeight: "bold",
      fontSize: 12,
      lineHeight: 0,
      fontFamily: "'Microsoft Tai Le'",
      InkscapeFontSpecification: "'Microsoft Tai Le Bold'",
      fill: "#dddddd"
    },
    transform: "translate(12.204,7.14)",
    "aria-label": "V"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWltLogoSmallEn);
export default __webpack_public_path__ + "static/media/wlt_logo_small_en.9daec8b0c0db4c005d01fd4dc144473b.svg";
export { ForwardRef as ReactComponent };